export const invalidTextSearchItem = { group: -1 };
export const emptyTextSearchItems = [invalidTextSearchItem];

export function getJobGroup(job) {
    return getHash(`${job.detail.part_id}_${job.other}`);
}

/**
 * @param {*} textSearchJobs jobsList. job должны содержать как минимум job_id, detail.part_id, other
 * @returns itemList где каждый item = { group: !== -1, jobs: [] }
 */
export function createItems(textSearchJobs) {
    let indeces = {};
    let items = [];

    for (let i = 0; i < textSearchJobs.length; ++i) {
        const job = textSearchJobs[i];
        const group = getJobGroup(job);

        if (indeces[group] === undefined) {
            indeces[group] = items.length;
            items.push({ group: group, jobs: [] });
        }
        items[indeces[group]].jobs.push(job);
    }
    return items;
};

export function removeJobFromItems(textSearchItems, targetJob) {
    if (!targetJob)
        return;

    const jobGroup = getJobGroup(targetJob);
    const itemIndex = textSearchItems.findIndex(item => item.group === jobGroup);
    if (itemIndex === -1 || itemIndex === 0)
        return;

    const item = textSearchItems[itemIndex];
    const jobIndex = item.jobs.findIndex(job => job.job_id === targetJob.job_id);
    if (jobIndex !== -1)
        item.jobs.splice(jobIndex, 1);

    if (item.jobs.length === 0) {
        textSearchItems.splice(itemIndex, 1);
    }
}

function getHash(str) {
    let hash = 0;
    if (str.length === 0)
        return hash;

    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash;
    }
    return hash;
}
